require('./statusWidget.style.scss');

class StatusWidgetController {
  constructor($element, $scope, $filter, $timeout) {
    this.$element = $element;
    this.$scope = $scope;
    this.$filter = $filter;
    this.dateFilter = $filter('localizeDate');
    this.$timeout = $timeout;
    this.period = 1000 * 60 * 60 * 48; //48h
    this.subtitle = 'Total 0';
    this.graphMax = 50;
  }

  $onInit() {
    this.$scope.$watch(() => this.renderCounter, () => {
      if (!this.items) {
        return;
      }
      this.itemClassesList = this.items.map(d => d.iconClass ? d.iconClass : d.class);
      this.baseOnIconClass = this.items.filter(d => d.iconClass).length;
      if (this.historyChart) {
        let chartMax = 0;
        let dataObject = {};
        this.items.forEach((d, i) => {
          dataObject['graph' + (i + 1)] = d.graph;
          if (d.graph.length > 0) {
            let currentGraphMax = _.max(_.map(d.graph, elem => elem.y));
            chartMax = chartMax > currentGraphMax ? chartMax : currentGraphMax;
          }
        });
        this.graphMax = chartMax + (chartMax % 10 ? 10 - chartMax % 10 : 0) || 10;
        this.totalCount = _.reduce(this.items, (res, elem) => res + elem.value, 0);
        this.graphData = dataObject;
      } else {
        this.donutData = this.items.map((d) => d.value);
      }
    });
    this.initHighlight();
  }

  initHighlight() {
    this.$timeout(() => {
      this.itemClassesList.forEach((item, index) => {
        this.$element.find('details-slot ' + 'i.' + item.split(' ')[0]).hover(
          () => {
            this.$timeout(() => {
              this.highlightedSlice = index;
            });
          },
          () => {
            this.$timeout(() => {
              this.highlightedSlice = undefined;
            });
          }
        );
      });
    });
  }

}

StatusWidgetController.$inject = ['$element', '$scope', '$filter', '$timeout'];

const statusWidgetComponent = {
  controller: StatusWidgetController,
  template: require('./statusWidget.template.html'),
  bindings: {
    widgetName: '@',
    widgetState: '@?',
    widgetDescription: '@?',
    items: '<',
    startTime: '<',
    chartColors: '<',
    donutPercentage: '<?',
    renderCounter: '<',
    widgetTitleTooltip: '@?',
    historyChart: '@'
  }
};

module.exports = statusWidgetComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/dashboard/components/statusWidget/statusWidget.component.js